import React from "react";

const SkillPill = ({ skill }) => {
    return (
        <div className="group relative flex items-center justify-between py-2 px-1 border-b border-gray-100/50 dark:border-white/5 last:border-0 hover:bg-primary/5 transition-colors duration-200 cursor-default">

            {/* 1. Skill Name & Interactive Insight */}
            <div className="flex items-center gap-2 overflow-hidden mr-4">
                <span className="text-[13px] font-bold text-gray-700 dark:text-gray-200 font-display whitespace-nowrap group-hover:text-primary transition-colors">
                    {skill.name}
                </span>

                {/* Insight: Appears inline on hover to save vertical space */}
                <span className="text-[10px] text-gray-400 font-medium opacity-0 group-hover:opacity-100 transition-all duration-300 truncate hidden md:block italic">
                    - {skill.insight}
                </span>
            </div>

            {/* 2. Proficiency Metrics */}
            <div className="flex items-center gap-3 shrink-0">
                {/* Percentage with Tabular Figures for alignment */}
                <span className="text-[10px] font-black text-gray-400 dark:text-gray-500 tabular-nums group-hover:text-primary transition-colors">
                    {skill.level}%
                </span>

                {/* Micro-Progress Bar: Ultra-slim to reduce visual noise */}
                <div className="w-10 h-1 bg-gray-100 dark:bg-gray-800 rounded-full overflow-hidden">
                    <div
                        className="h-full bg-primary/40 group-hover:bg-primary transition-all duration-[1200ms] ease-out"
                        style={{ width: `${skill.level}%` }}
                    />
                </div>
            </div>

            {/* 3. Subtle Interaction Highlight */}
            <div className="absolute inset-x-0 bottom-0 h-[1px] bg-primary/0 group-hover:bg-primary/10 transition-all" />
        </div>
    );
};

export default SkillPill;